/** Postcode → city/state lookup. */
import { endpoints } from '@/config/env';
import type { PostcodeDetails } from '@/types';
import { request } from './client';

interface PostcodeDetailsResponse {
  success: boolean;
  postcode_details: PostcodeDetails;
}

export async function fetchPostcodeDetails(postcode: string, signal?: AbortSignal): Promise<PostcodeDetails> {
  const response = await request<PostcodeDetailsResponse>(endpoints.postcodeDetails(postcode), { signal });
  return response.postcode_details;
}
